export default "/aFRAX.348e2e448fc9297efa1a160a1d0f102c.png";